// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2yIRd","content":"Consent_content__KrJ-6","footer":"Consent_footer__3piUi"};